export const PORTFOLIO_MODES = {
  standard: 'standard',
  customAssetClasses: 'customAssetClasses',
};
